import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { SM_CONSTANTS } from "../../constants/sm-constants";
import { LoaderServiceService } from "src/app/providers/loader-service.service";

@Component({
  selector: "sm-add-service-timings",
  templateUrl: "./add-service-timings.component.html",
  styleUrls: ["./add-service-timings.component.scss"],
})
export class AddServiceTimingsComponent implements OnInit,OnDestroy {
  meeting_details:any = ''
  userInfoFormGroup!: FormGroup;
  private _apiSubscription: Subscription = new Subscription();
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private activemodal: MatDialogRef<AddServiceTimingsComponent>,
    private loaderservice: LoaderServiceService,
    private _apiService: ApiService
  ) {
    this.userInfoFormGroup = new FormGroup({
      opentime: new FormControl(null, [Validators.required]),
      closetime: new FormControl(null, [Validators.required]),
    });
  }

  ngOnInit(): void {

    this.userInfoFormGroup.patchValue({
      opentime: this.formatTime("09:00"),
      closetime: this.formatTime("21:00")
    })
    
    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_HOME_SERVICE_TIMINGS
      ) {
        if (resData.result) {
          this.activemodal.close({msg:'success'})
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_SHOP_SERVICE_TIMINGS
      ) {
        if (resData.result) {
          this.activemodal.close({msg:'success'})
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_VIRTUAL_SERVICE_TIMINGS
      ) {
        if (resData.result) {
          this.activemodal.close({msg:'success'})
        }
      }
    });
  }

  onPost() {
    if (this.parentData.data.serviceType == "0") {
      let data = {
        homeServiceTimeInfo: {
          timeList: [
            {
              day: this.parentData.data.day,
              openTime: this.convertTo24HourFormat(
                this.userInfoFormGroup.value.opentime
              ),
              closeTime: this.convertTo24HourFormat(
                this.userInfoFormGroup.value.closetime
              ),
            },
          ],
        },
      };

      console.log(data);
      this.loaderservice.showLoader = true
      this._apiService.updateHomeServiceTimeInfo(
        this.parentData.data.entityHash,
        data
      );
    } else if (this.parentData.data.serviceType == "1") {
      let data = {
        entityTimeInfo: {
          timeList: [
            {
              day: this.parentData.data.day,
              openTime: this.convertTo24HourFormat(
                this.userInfoFormGroup.value.opentime
              ),
              closeTime: this.convertTo24HourFormat(
                this.userInfoFormGroup.value.closetime
              ),
            },
          ],
        },
      };

      console.log(data);
      this.loaderservice.showLoader = true
      this._apiService.updateEntityShopTimeInfo(
        this.parentData.data.entityHash,
        data
      );
    }
    else if (this.parentData.data.serviceType == "2") {
      // let data = {
      //   entityTimeInfo: {
      //     timeList: [
      //       {
      //         day: this.parentData.data.day,
      //         openTime: this.convertTo24HourFormat(
      //           this.userInfoFormGroup.value.opentime
      //         ),
      //         closeTime: this.convertTo24HourFormat(
      //           this.userInfoFormGroup.value.closetime
      //         ),
      //       },
      //     ],
      //   },
      // };

      let data = {
        "entityHash": this.parentData.data.entityHash,
        "timeList": [
            {
                "day": this.parentData.data.day,
                "openTime": this.convertTo24HourFormat(
                  this.userInfoFormGroup.value.opentime
                ),
                "closeTime": this.convertTo24HourFormat(
                  this.userInfoFormGroup.value.closetime
                ),
                "meeting_details": this.meeting_details && this.meeting_details != null && this.meeting_details != '' && this.meeting_details != 'null' ? this.meeting_details : null
            }
        ]
    }

      console.log(data);
      this.loaderservice.showLoader = true
      this._apiService.updateVirtualServiceTimingInfo(
        data
      );
    }
  }

  // convertTo24HourFormat(time: any) {
  //   // Parse the time string to a Date object
  //   const date = new Date(`2000-01-01 ${time}`);

  //   // Use Date methods to get hours, minutes, and seconds in 24-hour format
  //   const hours = date.getHours().toString().padStart(2, "0");
  //   const minutes = date.getMinutes().toString().padStart(2, "0");
  //   const seconds = date.getSeconds().toString().padStart(2, "0");

  //   // Concatenate hours, minutes, and seconds with colons

  //   console.log(`${hours}:${minutes}:${seconds}`);
    
  //   return `${hours}:${minutes}:${seconds}`;
  // }

  convertTo24HourFormat(time:any) {
    // Extract hours, minutes, and AM/PM from the time string
    const [timePart, amPm] = time.split(' ');
    const [hoursStr, minutesStr] = timePart.split(':');

    // Convert string components to numbers
    let hours = parseInt(hoursStr, 10);
    const minutes = parseInt(minutesStr, 10);

    // Adjust hours based on AM/PM
    if (amPm.toLowerCase() === 'pm' && hours !== 12) {
        hours += 12;
    } else if (amPm.toLowerCase() === 'am' && hours === 12) {
        hours = 0;
    }

    // Construct a new Date object with a fixed date and the parsed time components
    const date = new Date(2000, 0, 1, hours, minutes);

    // Use Date methods to get hours, minutes, and seconds in 24-hour format
    const formattedHours = date.getHours().toString().padStart(2, "0");
    const formattedMinutes = date.getMinutes().toString().padStart(2, "0");

    const formattedTime = `${formattedHours}:${formattedMinutes}`;

    console.log(formattedTime);

    return formattedTime;
}

  formatTime(inputTime: string): string {
    const [hours, minutes] = inputTime.split(':');
    let formattedHours = parseInt(hours, 10);
    let period = 'AM';

    if (formattedHours >= 12) {
      if (formattedHours > 12) {
        formattedHours -= 12;
      }
      period = 'PM';
    }

    if (formattedHours === 0) {
      formattedHours = 12;
    }

    return `${formattedHours}:${minutes} ${period}`;
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe()
  }
}
